// import Vue from 'vue'
import { userService } from "@/services";
import router from "@/router";

const userSession = localStorage.getItem("user");
const user = userSession ? JSON.parse(userSession) : null;

const state = {
  status: { loggedIn: user ? true : false },
  registerStatus: false,
  user: user,
  entertainmentStatus: false,
  entertainment: [],
  userMetaRequest: null,
  presenter: null,
  presenterVerified: null,
  socialLogin: null,
};

const actions = {
  Redirection({ dispatch, commit }, user) {
    commit("loginSuccess", user);
    if (user.presenter) {
      router.push("/");
    } else if (user.phrases.length < 1) {
      router.push("/phrases");
    } else if (user.categories.length < 1) {
      router.push("/categories");
    } else {
      router.push("/");
    }
  },
  async linkProfile(
    { dispatch, commit },
    { phoneNumber, username, email, password, isSocial, socialType, socialId }
  ) {
    return await userService
      .linkProfile(
        phoneNumber,
        username,
        email,
        password,
        isSocial,
        socialType,
        socialId
      )
      .then((user) => user, (error) => error);
  },
  loginSuccessData({ commit }, user) {
    commit("loginSuccess", user);
  },
  async login(
    { dispatch, commit },
    { username, phone, email, password, isSocial, socialType, socialId }
  ) {
    commit("loginRequest", { username });

    return await userService
      .login(username, phone, email, password, isSocial, socialType, socialId)
      .then(
        (user) => {
          if (user.error) {
            commit("loginFailure", user.message);
            dispatch("alert/error", user.message, { root: true });
            return user;
          }
          commit("loginSuccess", user);

          const tt = localStorage.getItem("recentLink");
          if (user.presenter && !tt) {
            router.push("/");
          } else if (user.phrases.length < 1) router.push("/phrases");
          else if (user.categories.length < 1) router.push("/categories");
          else if (!tt) {
            router.push("/");
          }
        },
        (error) => {
          commit("loginFailure", error);
          dispatch("alert/error", error, { root: true });
        }
      );
  },
  logout({ commit }) {
    userService.logout();
    commit("logout");
  },
  async verifyOTP({ dispatch, commit }, params) {
    return await userService.verifyOTP(params);
  },
  verifyEmail({ dispatch, commit }, params) {
    userService.verifyEmail(params);
  },

  updateProfile({ dispatch, commit }, params) {
    userService.updateProfile(params).then((user) => {
      localStorage.setItem("user", JSON.stringify(user));
      if (user.presenter) {
        router.push("/");
      } else if (user.phrases.length < 1) router.push("/phrases");
      else if (user.categories.length < 1) router.push("/categories");
      else router.push("/");
    });
  },
  async registerUsers({ dispatch, commit }, params) {
    commit("registerRequest", params.data);

    return await userService.register(params.data).then(
      (user) => {
        if (user.error) {
          commit("registerFailure", user.message);
          dispatch("alert/error", user.message, { root: true });
          return user;
        }
        return user;
      },
      (error) => {
        commit("registerFailure", error);
        dispatch("alert/error", error, { root: true });
      }
    );
  },
  async register({ dispatch, commit }, params) {
    commit("registerRequest", params.data);

    return await userService.register(params.data).then(
      (user) => {
        if (user.error) {
          commit("registerFailure", user.message);
          dispatch("alert/error", user.message, { root: true });
          return user;
        }
        userService.updateZip({
          userId: user.id,
          zipcode: params.data.get("zipcode"),
        });

        if (user && user.userId && user.password) {
          commit("loginSuccess", user);
          if (user.presenter && user.presenter != "null") {
            router.push("/");
          } else {
            const link = localStorage.getItem("recentregLink");

            localStorage.setItem("user", JSON.stringify(user));
            if (link) {
              router.push(link);
            } else {
              router.push("/phrases");
            }
          }

          return user;
        }
        commit("loginRequest", { username: user.username });
        userService
          .login(user.username, user.phoneNumber, user.email, params.password)
          .then(
            (loggedInUser) => {
              commit("loginSuccess", loggedInUser);
              if (loggedInUser.presenter) {
                router.push("/");
              } else {
                const link = localStorage.getItem("recentregLink");

                localStorage.setItem("user", JSON.stringify(loggedInUser));
                if (link) {
                  router.push(link);
                } else {
                  router.push("/phrases");
                }
              }
            },
            (error) => {
              commit("loginFailure", error);
              dispatch("alert/error", error, { root: true });
            }
          );
      },
      (error) => {
        commit("registerFailure", error);
        dispatch("alert/error", error, { root: true });
      }
    );
  },
  updateZip({ dispatch, commit }, params) {
    commit("userMetaRequest", {
      type: "zip",
      status: "STARTED",
      params: params,
      user: null,
    });
    userService.updateZip(params).then(
      (user) => {
        commit("userMetaRequest", {
          type: "zip",
          status: "SUCCESS",
          params: params,
          user: user,
        });
      },
      (error) => {
        commit("userMetaRequest", {
          type: "zip",
          status: "ERROR",
          params: params,
          error: error,
          user: user,
        });
        dispatch("alert/error", error, { root: true });
      }
    );
  },
  updateCategories({ dispatch, commit }, params) {
    commit("userMetaRequest", {
      type: "categories",
      status: "STARTED",
      params: params,
      user: null,
    });
    userService.updateCategories(params).then(
      (user) => {
        commit("userMetaRequest", {
          type: "categories",
          status: "SUCCESS",
          params: params,
          user: user,
        });
      },
      (error) => {
        commit("userMetaRequest", {
          type: "categories",
          status: "ERROR",
          params: params,
          error: error,
          user: user,
        });
        dispatch("alert/error", error, { root: true });
      }
    );
  },
  updateEntertainment({ dispatch, commit }, params) {
    commit("userMetaRequest", {
      type: "entertainment",
      status: "STARTED",
      params: params,
      user: null,
    });
    userService.updateEntertainment(params).then(
      (user) => {
        commit("userMetaRequest", {
          type: "entertainment",
          status: "SUCCESS",
          params: params,
          user: user,
        });
      },
      (error) => {
        commit("userMetaRequest", {
          type: "entertainment",
          status: "ERROR",
          params: params,
          error: error,
          user: user,
        });
        dispatch("alert/error", error, { root: true });
      }
    );
  },
  getEntertainment({ dispatch, commit }) {
    commit("entertainmentRequest");

    userService.getEntertainment().then(
      (entertainment) => {
        commit("entertainmentSuccess", entertainment);
      },
      (error) => {
        commit("entertainmentFailed", error);
        dispatch("alert/error", error, { root: true });
      }
    );
  },
  async verifyPresenter({ dispatch, commit }, { email }) {
    return await userService.verifyPresenter(email).then(
      (user) => {
        if (!user.error) {
          commit("presenterVerified", user);
        }
        return user;
      },
      (error) => {
        commit("presenterVerifyFailed", error);
        dispatch("alert/error", error, { root: true });
      }
    );
  },
  unfollowUser({ commit }, params) {
    return userService
      .unfollowUser(params)
      .then((user) => user, (error) => error);
  },

  followUser({ commit }, params) {
    return userService
      .followUser(params)
      .then((user) => user, (error) => error);
  },

  socialLoginRegisterData({ commit, state }, params) {
    state.socialLogin = params;
  },
};

const mutations = {
  loginRequest(state, user) {
    state.status = { loggingIn: true };
    state.user = user;
  },
  loginSuccess(state, user) {
    state.status = { loggedIn: true };
    state.user = user;
  },
  loginFailure(state) {
    state.status = {};
    state.user = null;
  },
  logout(state) {
    state.status = {};
    state.user = null;
  },
  registerRequest(state) {
    state.registerStatus = false;
  },
  registerSuccess(state) {
    state.registerStatus = true;
    state.user = null;
  },
  registerFailure(state) {
    state.registerStatus = false;
  },
  entertainmentRequest(state) {
    state.entertainmentStatus = false;
    state.entertainment = [];
  },
  entertainmentSuccess(state, entertainment) {
    state.entertainmentStatus = true;
    state.entertainment = entertainment;
  },
  entertainmentFailed(state) {
    state.entertainmentStatus = false;
    state.entertainment = [];
  },
  userMetaRequest(state, userMetaRequest) {
    state.userMetaRequest = userMetaRequest;
  },
  presenterVerified(state, user) {
    state.presenterVerified = true;
    state.presenter = user;
  },
  presenterVerifyFailed(state, user) {
    presenterVerified = false;
    state.presenter = null;
  },
};

export const account = {
  namespaced: true,
  state,
  actions,
  mutations,
};
